import { render, staticRenderFns } from "./PurN_Items.vue?vue&type=template&id=d368bf08"
import script from "./PurN_Items.vue?vue&type=script&lang=js"
export * from "./PurN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports